import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Teised tootega <span style="color:#a6d189;">**{title}**</span> seotud tooted

  <span style="color:#85c1dc;">**FI:**</span>
  Muut tuotteeseen <span style="color:#a6d189;">**{title}**</span> liittyvät tuotteet

  <span style="color:#85c1dc;">**RU:**</span>
  Другие продукты, связанные с товаром <span style="color:#a6d189;">**{title}**</span>
*/
/* @__NO_SIDE_EFFECTS__ */
const m713 = msg(
  mf`Teised tootega ${'title'} seotud tooted`,
  mf`Muut tuotteeseen ${'title'} liittyvät tuotteet`,
  mf`Другие продукты, связанные с товаром ${'title'}`,
)

export { m713 as 'w.module.tied_products_section.family' }